import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { GoalClockIcon } from "@/apps/goals/assets/icons";

import { WheelPreview } from "@/apps/goals/components/WheelPreview/WheelPreview";
import { GOAL_DURATION_MS } from "@/apps/goals/constants";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { useTimeLeft } from "@/apps/goals/hooks/useTimeLeft";
import { getGoalsScreenUrl } from "@/apps/goals/utils/goalsRoutes";
import Button from "@/ui/Button/Button";
import { formatTimeLeft } from "@/apps/goals/utils/formatTime";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

interface NextGoalCardProps {
  startsAt?: number;
}

export const NextGoalCard = ({ startsAt }: NextGoalCardProps) => {
  const { t } = useTranslation();
  const openWheel = useGoalsStore((state) => state.openWheel);
  const location = useLocation();
  const navigate = useNavigate();
  const fallbackTargetTime = useMemo(() => Date.now() + GOAL_DURATION_MS, []);
  const targetTime = startsAt ?? fallbackTargetTime;
  const timeLeft = useTimeLeft(targetTime);
  const isExpired = timeLeft <= 0;

  const handleOpenWheel = () => {
    openWheel();
    navigate({
      pathname: getGoalsScreenUrl("wheel"),
      search: location.search,
    });
  };

  if (isExpired)
    return (
      <Button
        className={cls.action}
        label={t("goals.active.tryLuck")}
        variant="primary"
        onClick={handleOpenWheel}
      />
    );

  return (
    <div className={cls.card}>
      <div className={cls.copy}>
        <Typography component="p" size="md" weight="bold">
          {t("goals.nextGoal.title")}
        </Typography>
        <div className={cls.timeBadge}>
          <GoalClockIcon />
          <Typography component="span" size="sm" weight="medium" family="Onest">
            {formatTimeLeft(timeLeft)}
          </Typography>
        </div>
      </div>
      <WheelPreview />
    </div>
  );
};
